import React from 'react';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Link from '@amzn/meridian/link';
import { Routes_Path } from 'src/router/Routes';
import { useBundle } from '@amzn/react-arb-tools';
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from 'src/utils/Constants';
import { t } from 'src/helpers';

const FooterComponent: React.FC = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <Row alignmentHorizontal="center" spacingInset="200">
      <Text type="b100" color="secondary">
        {t(bundle, 'swiship_footer_copyright')}{' '}
        <Link href={Routes_Path.SITE_TERMS} target="_blank" rel="noopener noreferrer">
          {t(bundle, 'swiship_footer_site_terms')}
        </Link>
        .
      </Text>
    </Row>
  );
};

export default FooterComponent;
